<script setup lang="ts">
import type { DashboardInventoryWinRow } from "../../features/dashboard/dashboard.types.ts";

defineProps<{
  rows: DashboardInventoryWinRow[];
}>();

function statusClass(tone: DashboardInventoryWinRow["beforeTone"]): string {
  switch (tone) {
    case "critical": {
      return "dashboard-status-badge--critical";
    }
    case "moderate": {
      return "dashboard-status-badge--moderate";
    }
    case "healthy": {
      return "dashboard-status-badge--healthy";
    }
    case "balanced": {
      return "dashboard-status-badge--balanced";
    }
    case "overstocked": {
      return "dashboard-status-badge--overstocked";
    }
  }
}
</script>

<template>
  <section class="dashboard-card rounded-[1.5rem] px-5 py-5">
    <div class="flex items-center justify-between gap-3">
      <h2 class="dashboard-text-primary text-lg font-semibold">
        Top Inventory Wins
      </h2>
      <span class="dashboard-text-muted text-xs"
        >Snapshot of the strongest improvements</span
      >
    </div>

    <div class="mt-4 overflow-x-auto">
      <table
        class="dashboard-text-secondary min-w-full border-collapse text-left text-sm"
      >
        <thead>
          <tr
            class="dashboard-divider dashboard-text-muted border-b text-xs tracking-[0.14em] uppercase"
          >
            <th class="pr-4 pb-3 font-semibold">SKU</th>
            <th class="pr-4 pb-3 font-semibold">Before</th>
            <th class="pr-4 pb-3 font-semibold">After</th>
            <th class="pr-4 pb-3 font-semibold">Improvement</th>
            <th class="pb-3 font-semibold">Business Outcome</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rows"
            :key="row.sku"
            class="border-b last:border-b-0"
            :style="{ borderColor: 'var(--dashboard-table-divider)' }"
          >
            <td class="dashboard-text-primary py-3 pr-4 font-medium">
              {{ row.sku }}
            </td>
            <td class="py-3 pr-4">
              <span
                class="dashboard-status-badge"
                :class="statusClass(row.beforeTone)"
              >
                {{ row.before }}
              </span>
            </td>
            <td class="py-3 pr-4">
              <span
                class="dashboard-status-badge"
                :class="statusClass(row.afterTone)"
              >
                {{ row.after }}
              </span>
            </td>
            <td class="dashboard-text-positive py-3 pr-4">
              {{ row.improvement }}
            </td>
            <td class="py-3">{{ row.outcome }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <RouterLink
      :to="{ name: 'search-select-pos' }"
      class="dashboard-text-link mt-4 inline-flex items-center gap-2 text-sm font-semibold no-underline"
    >
      View all inventory wins
      <span aria-hidden="true">›</span>
    </RouterLink>
  </section>
</template>
